import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const initialState = {
  holdingTank: false,
  placementModal: false,
  sideCard: false,
};

const CustomerTreeContext = createContext(initialState);

export const useCustomerTree = () => {
  const context = useContext(CustomerTreeContext);
  if (!context) {
    throw new Error('useCustomerTree must be used within CustomerTreeProvider');
  }
  return context;
};

export const CustomerTreeProvider = ({ children }) => {
  const [itemToggles, setItemToggles] = useState(initialState);

  const toggleHoldingTank = (toggle) => {
    setItemToggles((prev) => ({
      ...prev,
      holdingTank: toggle,
    }));
  };

  const togglePlacementModal = (toggle) => {
    setItemToggles((prev) => ({
      ...prev,
      placementModal: toggle,
    }));
  };

  const toggleSideCard = (toggle) => {
    setItemToggles((prev) => ({
      ...prev,
      sideCard: toggle,
    }));
  };

  return (
    <CustomerTreeContext.Provider
      value={{
        itemToggles,
        toggleHoldingTank,
        togglePlacementModal,
        toggleSideCard,
      }}
    >
      {children}
    </CustomerTreeContext.Provider>
  );
};

CustomerTreeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomerTreeContext;
